// src/app/services/toast.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ToastConfig } from 'src/app/pages/ui-components/shared/components/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastState = new BehaviorSubject<{ show: boolean; config: ToastConfig }>({
    show: false,
    config: {
      type: 'success',
      title: '',
      message: '',
      duration: 3000,
      showIcon: true,
      position: 'bottom-center'
    }
  });

  toastState$ = this.toastState.asObservable();

  showToast(type: 'success' | 'error' | 'warning' | 'info', title: string, message: string): void {
    this.toastState.next({
      show: true,
      config: {
        type,
        title,
        message,
        duration: 3000,
        showIcon: true,
        position: 'bottom-center'
      }
    });

    // Auto hide after duration
    setTimeout(() => {
      this.hideToast();
    }, 3000);
  }

  hideToast(): void {
    this.toastState.next({
      ...this.toastState.value,
      show: false
    });
  }
}